export const NAVIGATION = [
  {
  category: 'energy',
  icon: 'circle-bolt',
  items: [{
          icon: 'circle-bolt',
          key: 'dual',
          title: 'Gas & Electricity',
          url: '/compare-gas-electricity-prices/dual-fuel/'
      },
      {
          icon: 'lamp-floor',
          key: 'electricity',
          title: 'Electricity',
          url: '/compare-gas-electricity-prices/electricity/'
      },
      {
          icon: 'fire',
          key: 'gas',
          title: 'Gas',
          url: '/compare-gas-electricity-prices/gas/'
      },
      {
          icon: 'buildings',
          key: 'business',
          title: 'Business Energy',
          url: '/compare-gas-electricity-prices/business/'
      }
  ],
  guides: [{
          title: 'Get cheaper energy bills with our Quickstart Guide.',
          url: '/guides/gas-electricity/how-to-get-cheaper-energy-bills-on-bonkers-ie/'
      },
      {
          title: 'Which appliances use the most electricity?',
          url: '/guides/gas-electricity/which-appliances-use-the-most-electricity/'
      },
      {
          title: 'Latest gas and electricity price changes',
          url: '/price-change-calendar/?product=energy'
      },
      {
          title: 'Common questions about the switching process',
          url: '/guides/gas-electricity/switching-energy-supplier-frequently-asked-questions/'
      }
  ],
  cta: {
      icon: 'circle-bolt',
      title: 'Switch Gas & Electricity with bonkers.ie',
      desc: 'Find the cheapest energy deal and save on average',
      button: 'Get cheaper bills',
      url: '/compare-gas-electricity-prices/'
  }
},
{
  category: 'insurance',
  icon: 'shield-check',
  items: [{
          icon: 'car',
          key: 'ci',
          title: 'Car Insurance',
          url: '/compare-car-insurance/'
      },
      {
          icon: 'house-crack',
          key: 'hi',
          title: 'Home Insurance',
          url: '/compare-home-insurance/'
      },
      {
        icon: 'piggy-bank',
        key: 'ip',
        title: 'Income Protection',
        url: '/compare-income-protection-insurance/'
      },
      {
          icon: 'notes-medical',
          key: 'li',
          title: 'Life Insurance',
          url: '/compare-life-insurance/'
      },
      {
          icon: 'house-medical-flag',
          key: 'mp',
          title: 'Mortgage Protection Insurance',
          url: '/compare-mortgage-protection-insurance/'
      },
      {
          icon: 'hospitals',
          key: 'si',
          title: 'Serious Illness',
          url: '/compare-serious-illness-cover/'
      },
      {
        icon: 'note-medical',
        key: 'health',
        title: 'Health Insurance',
        url: '/compare-health-insurance/'
      }
  ],
  guides: [{
          title: 'Read our guide on how to lower your insurance costs.',
          url: '/guides/insurance/simple-ways-to-reduce-your-insurance-costs/'
      },
      {
          title: 'Get to grips with these general insurance terms.',
          url: '/guides/insurance/23-common-insurance-terms-explained/'
      },
      {
          title: 'Discover the most common life insurance questions.',
          url: '/guides/insurance/15-common-life-insurance-questions-answered/'
      },
      {
          title: 'Top things to consider when taking out car insurance.',
          url: '/guides/insurance/12-things-to-consider-when-taking-out-car-insurance/'
      }
  ],
  cta: {
      icon: 'shield-check',
      title: 'Get insurance cover with bonkers.ie',
      desc: 'Apply online and get cover in under an hour',
      button: 'Find the best cover',
      url: '/compare-insurance/'
  }
},
{
  category: 'broadband',
  icon: 'house-signal',
  items: [{
      icon: 'house-signal',
      key: 'broadband',
      title: 'Broadband',
      url: '/compare-tv-broadband-phone/'
  }],
  guides: [{
          title: 'Find better value broadband with our Quickstart Guide.',
          url: '/guides/broadband-phone-tv/quickstart-guide-how-to-get-the-best-value-broadband-tv-and-phone-deals-on-bonkers-ie/'
      },
      {
          title: 'Get to grips with these common broadband terms',
          url: '/guides/broadband-phone-tv/21-common-broadband-terms-explained/'
      },
      {
          title: 'Latest gas and electricity price changes',
          url: '/price-change-calendar/'
      },
      {
          title: 'Common questions about the switching process',
          url: '/guides/broadband-phone-tv/switching-broadband-provider-frequently-asked-questions/'
      }
  ],
  cta: {
      icon: 'house-signal',
      title: 'Switch broadband with bonkers.ie',
      desc: 'Get the best broadband, phone and TV deals from',
      button: 'Get the best deal',
      url: '/compare-tv-broadband-phone/'
  }
},
{
  category: 'mortgages',
  icon: 'key',
  items: [{
          icon: 'key',
          key: 'ftb',
          title: 'First Time Buyer',
          url: '/compare-mortgages/first-time-buyer/stage/'
      },
      {
          icon: 'truck-ramp-couch',
          key: 'trd',
          title: 'Moving Home',
          url: '/compare-mortgages/moving-home/stage/'
      },
      {
          icon: 'house-person-return',
          key: 'sm',
          title: 'Switching Mortgage',
          url: '/compare-mortgages/switching-mortgage/stage/'
      },
      {
        icon: 'sack',
        key: 'll',
        title: 'Lifetime Loan (Equity Release)',
        url: '/compare-mortgages/lifetime-loans/'
    }
  ],
  guides: [{
          title: 'Find the right mortgage with our Quickstart Guide.',
          url: '/guides/mortgage/using-bonkers-to-compare-mortgages/'
      },
      {
          title: 'Get to grips with these common mortgage terms',
          url: '/guides/mortgage/25-common-mortgage-terms-explained/'
      },
      {
          title: 'What documents you need to apply for a mortgage',
          url: 'guides/mortgage/what-documents-do-you-need-to-apply-for-a-mortgage/'
      },
      {
          title: 'Common questions we get asked about applying for a mortgage',
          url: '/guides/mortgage/13-common-mortgage-questions-answered/'
      }
  ],
  cta: {
      icon: 'house',
      title: 'Arranging a mortgage is easy with bonkers.ie',
      desc: 'Our mortgage broker service is absolutely free',
      button: 'Arrange your mortgage',
      url: '/compare-mortgages/'
  }
},
{
  category: 'banking',
  icon: 'piggy-bank',
  items: [{
          icon: 'vault',
          key: 'savings',
          title: 'Savings Accounts',
          url: '/compare-savings-accounts/'
      },
      {
          icon: 'money-bill-wave',
          key: 'currents',
          title: 'Current Accounts',
          url: '/compare-current-accounts/'
      },
      {
          icon: 'credit-card',
          key: 'credit',
          title: 'Credit Cards',
          url: '/compare-credit-cards/'
      },
      {
          icon: 'credit-card-front',
          key: 'prepay',
          title: 'Prepaid Credit Cards',
          url: '/compare-prepaid-credit-cards/'
      },
      {
          icon: 'coin',
          key: 'loans',
          title: 'Personal Loans',
          url: '/compare-loans/'
      }
  ],
  guides: [{
          title: 'Read our guide on essential savings tips for Irish households.',
          url: '/guides/personal-finance/the-essential-savings-guide-for-irish-households/'
      },
      {
          title: 'Get to grips with the most common general banking terms.',
          url: '/guides/personal-finance/28-general-banking-terms-explained/'
      },
      {
          title: 'Discover the most common mortgage questions we get asked.',
          url: '/guides/mortgage/13-common-mortgage-questions-answered/'
      },
      {
          title: 'Here are the top things to consider when selecting a current account.',
          url: '/guides/personal-finance/8-things-to-consider-when-choosing-a-new-current-account-provider/'
      }
  ],
  cta: {
      icon: 'piggy-bank',
      title: 'Lower your everyday banking costs',
      desc: 'Find the best banking options for you in minutes',
      button: 'Find the best rates',
      url: '/money/'
  }
},
{
  category: 'newsroom',
  icon: 'newspaper',
  items: [{
          icon: 'newspaper',
          key: 'blog',
          title: 'Latest News',
          url: '/blog/'
      },
      {
          icon: 'message-lines',
          key: 'guides',
          title: 'Guides',
          url: '/guides/'
      },
      {
          icon: 'tower-broadcast',
          key: 'media',
          title: 'In the Media',
          url: '/media/'
      },
      {
          icon: 'podcast',
          key: 'podcasts',
          title: 'Podcasts',
          url: '/podcasts/'
      },
      {
          icon: 'rectangle-ad',
          key: 'ads',
          title: 'Ads',
          url: '/ads/'
      },
      {
          icon: 'square-poll-vertical',
          key: 'priceChanges',
          title: 'Price Changes',
          url: '/price-change-calendar/'
      },
      {
          icon: 'magnifying-glass-chart',
          key: 'marketAnalysis',
          title: 'Market Analysis',
          url: '/market-analysis/'
      }
  ],
  guides: [{
          title: 'Bank of Ireland ups its fixed mortgage rates for second time this year',
          url: '/guides/energy/'
      },
      {
          title: 'Which bank has the best mortgage rates for first-time buyers?',
          url: '/guides/energy/'
      },
      {
          title: 'Raisin Bank: the alternative option for Irish savers',
          url: '/guides/energy/'
      },
      {
          title: 'Ireland’s financial literacy lags its peers according to new study',
          url: '/guides/energy/'
      }
  ],
  cta: {
      icon: 'newspaper',
      title: 'The latest news, guides, and radio interviews',
      desc: 'Take a look at our news, guide resources, and tips on how to save!',
      button: 'Read the latest news',
      url: '/newsroom/'
  }
}
];
